import { useEffect, useRef, useState } from "react";
import {
  TransportSedel,
  TransportSedelStatus,
} from "types/transportSedel.type";

const CELEBRATION_DURATION_MS = 3000;

/**
 * Detekterar när en transportsedel byter status till Lastad (inte om den
 * redan är lastad vid mount) och håller `isCelebrating` sann en kort stund
 * så UI:t kan visa en bekräftelse.
 */
export const useLoadedCelebration = (
  transportSedel: TransportSedel,
): { isCelebrating: boolean } => {
  const prevStatusRef = useRef(transportSedel.status);
  const [isCelebrating, setIsCelebrating] = useState(false);

  useEffect(() => {
    const cameFromOtherStatus =
      prevStatusRef.current !== TransportSedelStatus.LoadedOnTruck;
    prevStatusRef.current = transportSedel.status;

    if (
      cameFromOtherStatus &&
      transportSedel.status === TransportSedelStatus.LoadedOnTruck
    ) {
      setIsCelebrating(true);
      const timeout = setTimeout(
        () => setIsCelebrating(false),
        CELEBRATION_DURATION_MS,
      );
      return () => clearTimeout(timeout);
    }
  }, [transportSedel.status]);

  return { isCelebrating };
};
